import { render, staticRenderFns } from "./CompletePurchaseDialog.vue?vue&type=template&id=d8d1f476&scoped=true&lang=pug&"
import script from "./CompletePurchaseDialog.vue?vue&type=script&lang=ts&"
export * from "./CompletePurchaseDialog.vue?vue&type=script&lang=ts&"
import style0 from "./CompletePurchaseDialog.vue?vue&type=style&index=0&id=d8d1f476&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8d1f476",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VForm } from 'vuetify/lib/components/VForm';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VForm,VSpacer,VTextField})
